import { Skeleton } from '@mantine/core';
import { useSetAtom } from 'jotai';
import { activeStepAtom } from '~/atoms/no-code-atoms';
import type { AutoHealConfig } from '@prisma/client';
import type { SelectedStep } from '~/server/logic/prisma/step-select';
import OperationList from '../operation/OperationList';

// TODO: deprecate this component
export default function OperationListStep({
  step,
  testContentId,
  isGenerating,
  readonly,
  disabled,
  stepIdx,
  handleOperationClick,
  autoHealConfig,
  autoHealCycleLimit,
}: {
  step: SelectedStep;
  testContentId: string;
  isGenerating?: boolean;
  readonly?: boolean;
  disabled?: boolean;
  stepIdx: number;
  handleOperationClick?: (event: React.MouseEvent<HTMLDivElement>, operationId: string, step: SelectedStep) => void;
  autoHealConfig: AutoHealConfig;
  autoHealCycleLimit: number;
}) {
  const setActiveStep = useSetAtom(activeStepAtom);

  return (
    <div
      className="w-full"
      onClick={() => {
        setActiveStep(step);
      }}
    >
      <OperationList
        step={step}
        testContentId={testContentId}
        operations={step?.operations || []}
        readonly={readonly}
        disabled={disabled}
        stepIdx={stepIdx}
        handleOperationClick={handleOperationClick}
        autoHealConfig={autoHealConfig}
        autoHealCycleLimit={autoHealCycleLimit}
      />
      {isGenerating ?
        <div className="px-4 py-1">
          <Skeleton className="h-8">-</Skeleton>
        </div>
      : null}
    </div>
  );
}
